const BASEROCK_API_URL_BASE = `${window.location.origin}/api/`
// const BASEROCK_API_URL_BASE = "http://127.0.0.1:8000/api/"; // for development outside of kubernetes.
const BASEROCK_API_VERSION = "v1";
const BASEROCK_API_URL = `${BASEROCK_API_URL_BASE}${BASEROCK_API_VERSION}`;
const DATA_PAGE_PAGE_LIMIT = 100000;
export {BASEROCK_API_URL, DATA_PAGE_PAGE_LIMIT};
